/* eslint-disable */
export default {
  en: 'Englisch',
  ja: 'Japanisch',
  fr: 'Französisch',
  de: 'Deutsch',
  es: 'Spanisch',
  it: 'Italienisch',
  pt: 'Portugiesisch',
  zh: 'Chinesisch',
  nl: 'Niederländisch',
  ko: 'Koreanisch',
  fi: 'Suomi',
} as const;

// @key: @#@"en"@#@ @source: @#@"English"@#@
// @key: @#@"ja"@#@ @source: @#@"Japanese"@#@
// @key: @#@"fr"@#@ @source: @#@"French"@#@
// @key: @#@"de"@#@ @source: @#@"Deutsch"@#@
// @key: @#@"es"@#@ @source: @#@"Spanish"@#@
// @key: @#@"it"@#@ @source: @#@"Italian"@#@
// @key: @#@"pt"@#@ @source: @#@"Portuguese"@#@
// @key: @#@"zh"@#@ @source: @#@"Chinese"@#@
// @key: @#@"nl"@#@ @source: @#@"Dutch"@#@
// @key: @#@"ko"@#@ @source: @#@"Korean"@#@
// @key: @#@"fi"@#@ @source: @#@"Suomi"@#@
